const createHistoryEntryUrl = leadId =>
  `/search/history/${leadId}`

export default createHistoryEntryUrl
